import { useNavigate, useLocation } from 'react-router-dom';
import { DeviceMobile } from '@phosphor-icons/react';
import { Modal, Btn } from '../ui/index';
import { useAuth } from '../../store/AuthContext';

function phoneIsVerified(user) {
  if (!user) return true;
  return !!user.phone_registred;
}

export default function PhoneRequiredDialog() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const onEditPage = location.pathname === '/profile/edit';
  const open = !!user && !phoneIsVerified(user) && !onEditPage;

  const goToEdit = () => {
    navigate('/profile/edit', { state: { requirePhone: true } });
  };

  return (
    <Modal open={open} onClose={() => {}} closable={false} title="ثبت شماره تماس الزامی است" width={440}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: 16 }}>
        <div style={{ color: '#233A7A' }}><DeviceMobile size={48} weight="duotone" /></div>
        <p style={{ margin: 0, fontSize: 14, color: '#475569', lineHeight: 1.7 }}>
          برای استفاده از سامانه باید ابتدا شماره تماس خود را ثبت و احراز هویت کنید.
        </p>
        <Btn onClick={goToEdit} style={{ minHeight: 44, width: '100%' }}>
          ثبت شماره تماس
        </Btn>
      </div>
    </Modal>
  );
}
